import styled, { css } from 'styled-components';
import { flexColumn, flexCenterVertical } from '@stylesheets/helpers';

export const CreateRow = styled.form`
  display: flex;
  align-items: flex-end;

  ${({ theme: { spacing, colors } }) => css`
    gap: ${spacing.level4};
    padding: ${spacing.level4};
    border-bottom: 1px solid ${colors.surfaceContainerHighest};
  `}

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const GroupList = styled.div`
  ${flexColumn};
`;

export const GroupItem = styled.div`
  ${flexColumn};

  ${({ theme: { spacing, colors } }) => css`
    gap: ${spacing.level3};
    padding: ${spacing.level4};
    border-bottom: 1px solid ${colors.surfaceContainerHighest};

    &:last-child {
      border-bottom: none;
    }
  `}
`;

export const GroupHeader = styled.div`
  ${flexCenterVertical};
  justify-content: space-between;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level3};
  `}
`;

export const GroupNameCell = styled.div`
  ${flexColumn};

  ${({ theme: { spacing, font, colors } }) => css`
    gap: ${spacing.level1};
    font-size: ${font.bodyMedium.fontSize};
    color: ${colors.onSurface};
  `}
`;

export const GroupMeta = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.bodySmall.fontSize};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const GroupActions = styled.div`
  ${flexCenterVertical};

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level2};
  `}
`;

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level2};
  `}
`;

export const MemberChip = styled.span`
  ${flexCenterVertical};

  ${({ theme: { spacing, borderRadius, font, colors } }) => css`
    gap: ${spacing.level2};
    padding: ${spacing.level2} ${spacing.level3};
    border-radius: ${borderRadius.full};
    font-size: ${font.bodySmall.fontSize};
    background: ${colors.secondaryContainer};
    color: ${colors.onSecondaryContainer};
  `}
`;

export const ActionIcon = styled.span`
  display: inline-flex;

  ${({ theme: { spacing } }) => css`
    & button {
      padding: 0;
    }

    & button > span {
      padding: ${spacing.level2};
    }

    & svg {
      width: 18px;
      height: 18px;
    }
  `}
`;

export const ChipRemove = styled.button`
  ${flexCenterVertical};
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;

  ${({ theme: { colors } }) => css`
    color: ${colors.onSurfaceVariant};

    &:hover {
      color: ${colors.onSurface};
    }

    & svg {
      width: 16px;
      height: 16px;
    }
  `}
`;

export const AddRow = styled.div`
  ${flexCenterVertical};

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level3};
    padding-top: ${spacing.level2};
  `}
`;

export const PickerWrap = styled.div`
  flex: 1;
  min-width: 220px;
`;

export const EmptyText = styled.p`
  margin: 0;

  ${({ theme: { font, colors, spacing } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    color: ${colors.onSurfaceVariant};
    padding: ${spacing.level4};
  `}
`;

export const HintText = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.bodySmall.fontSize};
    color: ${colors.onSurfaceVariant};
    font-style: italic;
  `}
`;
